// extracted by mini-css-extract-plugin
module.exports = {"content":"_02712f2b3b--content--AVB5E","spinner":"_02712f2b3b--spinner--eaPzg","heading":"_02712f2b3b--heading--P2RPS"};